import React from 'react';

import { SvgIconProps } from '@ui-core/types';

import BaseIcon from '../base-icon';

const SvgIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8423 9.21966C16.1352 9.51258 16.1352 9.98742 15.8423 10.2803L11.3423 14.7803C11.2014 14.9212 11.0103 15.0002 10.8111 15C10.6119 14.9998 10.4209 14.9203 10.2804 14.7791L8.1604 12.6491C7.8682 12.3555 7.86928 11.8806 8.16286 11.5884C8.45644 11.2962 8.93134 11.2973 9.22354 11.5909L10.8132 13.1881L14.7816 9.21966C15.0745 8.9268 15.5494 8.9268 15.8423 9.21966Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.75C7.44366 3.75 3.75 7.44366 3.75 12C3.75 16.5563 7.44366 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44366 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61524 6.61524 2.25 12 2.25C17.3848 2.25 21.75 6.61524 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61524 21.75 2.25 17.3848 2.25 12Z"
      />
    </BaseIcon>
  );
};

export default SvgIcon;
